import React, {Component} from 'react';
import {Button} from "reactstrap";

class AreaSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listValues : ""
        }
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }

    componentWillReceiveProps(nextProps) {

    }

    onKeyUp(e) {
        let charlimit = 16; // char limit per line
        let lines = e.target.value.split('\n');
        for (let i = 0; i < lines.length; i++) {
            if (lines[i].length <= charlimit)
                continue;
            let j = 0;
            let spaceChar = charlimit;
            while (j++ <= charlimit) {
                if (lines[i].charAt(j) === ' ')
                    spaceChar = j;
            }
            lines[i + 1] = lines[i].substring(spaceChar + 1) + (lines[i + 1] || "");
            lines[i] = lines[i].substring(0, spaceChar);
        }
        e.target.value = lines.slice(0, 10).join('\n');
    }

    onClick() {
        if (this.state.isListOpen) {
            this.setState({isListOpen: false});
        } else {
            this.setState({isListOpen: true});
        }
    }

    onChange(e) {
        let list = e.target.value;
        this.setState({listValues: list});
    }

    fetchData() {
        let self = this;
        let isContinue = false;
        let regex = new RegExp("^([A-Z0-9]{3})2([0-9]{12})$");
        let newArr = [];
        if(self.state.listValues !== ""){
            let arrValues = self.state.listValues.match(/.{1,16}/g);
            if(arrValues){
                for(let i = 0; i < arrValues.length ; i++){
                    if(arrValues[i].match(regex)){
                        newArr.push(arrValues[i]);
                        isContinue = true;
                    }
                }
            }
            self.props.handleSearch(newArr);
        }
        self.props.handleSearch(newArr);
    }


    render() {
        return (
            <div>
                <div>{this.props.header}
                    <a onClick={this.onClick}>
                        <span className="">{" "}</span>
                        <i className="fa fa-search"/>
                    </a>
                </div>

                {this.state.isListOpen &&
                    <div className="">
                        <div id="checkboxes">
                            <a style={{position:'absolute', zIndex : '1',
                                right: '5px', top: '-3px', padding: '5px', fontSize:'12px'}}
                               onClick={this.onClick}>x</a>
                            <div className='col-sm-12' style={{padding: '2px 5px 5px 2px'}}>
                                <div className='row'>
                                    <div className="col-md-8" style={{paddingTop: '3px'}}>
                                        <p>Çoklu {this.props.header} :</p>
                                    </div>
                                </div>
                            </div>
                            <textarea className="form-textarea"
                                      type="text"
                                      cols={5}
                                      rows={5}
                                      data-vlength="2,350"
                                      id="belgeNo"
                                      value={this.state.listValues}
                                      onKeyUp={(e) => this.onKeyUp(e)}
                                      onChange={(e) => this.onChange(e)}/>
                            <div>
                                <Button className="TekBtn onizle"
                                        style={{
                                            marginTop: '10px',
                                            background: '#70a0bf',
                                        }}
                                        onClick={this.fetchData}
                                >Sorgula</Button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default AreaSearch;
